import { Component } from '@theme/component';

// Keep YMQ's actual inputs, upload handling and production property names intact.
class TGFJewelryPhotoForm extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.observer?.disconnect();
    this.form = this.closest('form');
    this.copy = JSON.parse(this.querySelector('[data-jewelry-copy]').textContent);
    if (!this.form) return;
    this.observer = new MutationObserver(() => this.schedule());
    this.observer.observe(this.form, { childList: true, subtree: true });
    this.schedule();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
    this.frame = null;
  }

  schedule() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => { this.frame = null; this.enhance(); });
  }

  enhance() {
    const root = this.form.querySelector(`tgf-options[data-tgf-option-product-id="${this.dataset.productId}"]`);
    const box = suffix => root?.querySelector(`[data-tgf-option-id="${this.dataset.optionPrefix}tem${suffix}"]`);
    const size = box(2), photo = box(8), name = box(3), description = box(7);
    if (!size || !photo?.querySelector('input[type="file"]') || !name || !description) return;
    root.classList.add('tgf-jewelry-options');
    const title = (element, text, step) => {
      const label = element.querySelector('.tgf_lable');
      if (label && label.textContent !== text) label.textContent = text;
      element.dataset.jewelryStep = step;
      const input = element.querySelector('input[type="text"],input[type="file"]');
      if (input) input.setAttribute('aria-label', text);
    };
    title(size, this.copy.size, '1');
    title(photo, this.copy.photo, '2');
    title(name, this.copy.name, '3');
    size.classList.add('tgf-jewelry-size');
    photo.classList.add('tgf-jewelry-photo');
    for (const input of size.querySelectorAll('input[type="radio"]')) {
      const label = input.closest('label');
      if (!label || label.querySelector('.tgf-jewelry-size-card')) continue;
      const small = input.value === 'Küçük (25mm)';
      label.parentElement.parentElement.classList.add('tgf-jewelry-size-grid');
      const card = document.createElement('span'); card.className = 'tgf-jewelry-size-card';
      const heading = document.createElement('strong'); heading.textContent = small ? this.copy.small : this.copy.large;
      const dimensions = document.createElement('span'); dimensions.textContent = small ? '25 mm' : '30 mm';
      card.append(heading, dimensions); label.append(card);
      input.setAttribute('aria-label', `${heading.textContent} · ${dimensions.textContent}`);
    }
    const nameInput = name.querySelector('input[type="text"]');
    if (nameInput) nameInput.placeholder = this.copy.placeholder;
    if (root.querySelector('.tgf-jewelry-info')) return;

    const note = (parent, text, className) => {
      const p = document.createElement('p'); p.className = className; p.textContent = text; parent.append(p);
    };
    note(photo, this.copy.photoHelp, 'tgf-jewelry-help');
    note(name, this.copy.sides, 'tgf-jewelry-help');
    const details = document.createElement('details'); details.className = 'tgf-jewelry-info';
    const summary = document.createElement('summary');
    const infoTitle = document.createElement('span'); infoTitle.textContent = this.copy.info;
    const marker = document.createElement('span'); marker.textContent = '+'; marker.setAttribute('aria-hidden', 'true');
    summary.append(infoTitle, marker); details.append(summary, description);
    // Preserve the full production disclosure while making the initial form scannable.
    root.append(size, photo, name);
    note(root, this.copy.drawing, 'tgf-jewelry-drawing-note');
    root.append(details);
  }
}

if (!customElements.get('tgf-jewelry-photo-form')) customElements.define('tgf-jewelry-photo-form', TGFJewelryPhotoForm);
